(() => {
  "use strict";

  const locale = document.documentElement.lang.toLowerCase().replace(/_/g, "-").split("-")[0];
  const routeRoot = window.Shopify?.routes?.root;
  if (locale !== "ar" || typeof routeRoot !== "string" || !/^\/ar(?:-[a-z]{2})?\/$/i.test(routeRoot)) return;

  const contentSelector = ".rte, .rich-text";
  const excluded = "header, footer, nav, form, localization-form, .localization-form, [data-localization-form], [data-language-selector], [data-localization-selector], [role='navigation']";
  const allowed = /^\/(products|collections|pages|blogs|policies|search|cart)(\/|$)/;
  const downloadFile = /\.(?:pdf|zip|rar|7z|tar|gz|docx?|xlsx?|pptx?|csv|txt|json|xml|png|jpe?g|gif|webp|svg|mp[34]|mov|wav)$/i;
  const watched = new WeakSet();

  const translateHref = anchor => {
    if (anchor.closest(excluded) || anchor.hasAttribute("download") || anchor.hasAttribute("hreflang")) return;
    if ((anchor.getAttribute("rel") || "").split(/\s+/).includes("alternate")) return;
    const raw = anchor.getAttribute("href");
    if (!raw || /^[#?]/.test(raw.trim())) return;
    let url;
    try {
      url = new URL(raw, window.location.href);
    } catch {
      return;
    }
    if (!["http:", "https:"].includes(url.protocol) || url.origin !== window.location.origin) return;
    if (url.pathname !== "/" && !allowed.test(url.pathname)) return;
    if (downloadFile.test(url.pathname) || ["download", "locale", "language", "country", "currency"].some(key => url.searchParams.has(key))) return;
    const next = routeRoot + url.pathname.slice(1) + url.search + url.hash;
    if (raw !== next) anchor.setAttribute("href", next);
  };

  const watchContainer = (root, main) => {
    if (watched.has(root) || root.closest(excluded)) return;
    const ancestor = root.parentElement?.closest(contentSelector);
    if (ancestor && main.contains(ancestor) && watched.has(ancestor)) return;
    watched.add(root);
    const render = () => root.querySelectorAll("a[href]").forEach(translateHref);
    const options = { childList: true, attributes: true, attributeFilter: ["href"], subtree: true };
    const observer = new MutationObserver(() => {
      observer.disconnect();
      try {
        render();
      } finally {
        observer.observe(root, options);
      }
    });
    render();
    observer.observe(root, options);
  };

  const boot = () => {
    const main = document.getElementById("MainContent");
    if (!main) return;
    const marker = Symbol.for("boothlights.arabicContentLinks");
    if (window[marker]) return;
    window[marker] = true;
    const discover = element => {
      if (!(element instanceof Element) || !main.contains(element)) return;
      if (element.matches(contentSelector)) watchContainer(element, main);
      element.querySelectorAll(contentSelector).forEach(root => watchContainer(root, main));
    };
    discover(main);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element && !node.parentElement?.closest(contentSelector)) discover(node);
        }
      }
    });
    observer.observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();

